import { Container } from '@mui/material';
import { AddResource } from 'components/templates';
import React from 'react';

export const ResourceFormView = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <AddResource />
    </Container>
  );
};
